import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { Select } from "@/shared/components/organisms/Select";

interface CreateLeadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (formData: any) => void;
  isLoading: boolean;
}

interface FormValues {
  name: string;
  sex: string;
  birthday: string;
  email: string;
  phone: string;
  comment: string;
}

const initialFormValues: FormValues = {
  name: "",
  sex: "",
  birthday: "",
  email: "",
  phone: "",
  comment: "",
};

export const CreateLeadModal = memo<CreateLeadModalProps>(
  ({ isOpen, onClose, onSubmit, isLoading }) => {
    const { t } = useTranslation();
    const [formValues, setFormValues] = useState<FormValues>(initialFormValues);

    const handleChange = (
      e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
      const { name, value } = e.target;
      setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (value: { id: string; name: string }) => {
      setFormValues((prev) => ({ ...prev, sex: value.id }));
    };

    const handleSubmit = () => {
      onSubmit(formValues);
      setFormValues(initialFormValues);
    };

    const optionsSex = [
      { id: "Hombre", name: t("user.views.man", "Hombre") },
      { id: "Mujer", name: t("user.views.female", "Mujer") },
    ];

    return (
      <DialogCreate
        open={isOpen}
        setOpen={onClose}
        tittle="Nuevo lead"
        tittleButtonCreate="Crear"
        isLoading={isLoading}
        tittleButtonCancel="Cancelar"
        OnclickCreate={handleSubmit}
        OnclickCancel={onClose}
      >
        <div className="px-6 pt-6">
          <div className="space-y-4">
            <InputWithCornerHint
              label={t("user.views.name", "Nombre completo")}
              span={t("general.mandatory", "Obligatorio")}
              id="name"
              name="name"
              type="text"
              placeholder={t(
                "user.views.name_last_placeholder",
                "Nombre y apellidos"
              )}
              value={formValues.name}
              onChange={handleChange}
            />
            <Select
              name="sex"
              span={t("general.mandatory", "Obligatorio")}
              options={optionsSex}
              tittle={t("user.views.sex", "Sexo")}
              selected={optionsSex.find(
                (option) => option.id === formValues.sex
              )}
              setSelected={handleSelectChange}
            />
            <InputWithCornerHint
              label={t("user.views.birthday", "Fecha de nacimiento")}
              span={t("general.mandatory", "Obligatorio")}
              id="birthday"
              name="birthday"
              type="date"
              placeholder={t(
                "user.views.birthday_placeholder",
                "Fecha de nacimiento"
              )}
              value={formValues.birthday}
              onChange={handleChange}
            />
            <InputWithCornerHint
              label={t("user.views.email", "Correo electrónico")}
              span={t("general.mandatory", "Obligatorio")}
              id="email"
              name="email"
              type="email"
              placeholder={t(
                "user.views.email_placeholder",
                "Correo electrónico"
              )}
              value={formValues.correo}
              onChange={handleChange}
            />
            <InputWithCornerHint
              label={t("user.views.phone", "Teléfono")}
              span={t("general.mandatory", "Obligatorio")}
              id="phone"
              name="phone"
              type="tel"
              placeholder={t("user.views.phone_placeholder", "Teléfono")}
              value={formValues.phone}
              onChange={handleChange}
            />
            <InputWithCornerHint
              label={t("user.views.comment", "Comentario")}
              id="comment"
              name="comment"
              type="text"
              placeholder={t("user.views.comment_placeholder", "Comentario")}
              value={formValues.comment}
              onChange={handleChange}
            />
          </div>
        </div>
      </DialogCreate>
    );
  }
);
